import { CommandRequestType } from "../../authentication/connection/commandRequestType";
import { ICommandParameters } from "../../authentication/connection/iCommandParameters";
import { ICommandResponse } from "../../authentication/connection/iCommandResponse";
import { ErrorDetails, IAddPassengerUserRequestDto } from "../../authentication/connection/interfaces/apiInterfaces";
import { IRequestCommand } from "../../authentication/connection/iRequestCommand";

export class EditPassengerUserCommand extends IRequestCommand<
  IAddPassengerUserResponse,
  ErrorDetails,
  IEditPassengerUserParameters
> {
  public override setParameters(passengerUserParameter: IEditPassengerUserParameters) {
    this._commandType = CommandRequestType.PUT  ;
    this._commandUrl = `passengers/${passengerUserParameter.passengerUserId}${(passengerUserParameter.fareId ? '?travelFareId=' + passengerUserParameter.fareId.toString() : '')}`;
    this._commandBody = passengerUserParameter;
  }
}

export interface IEditPassengerUserParameters
  extends IAddPassengerUserRequestDto,
    ICommandParameters {
  passengerUserId?: number,
  fareId?: number
}

export interface IAddPassengerUserResponse extends ICommandResponse {}
